import { defineFcm } from '../shared/factory';

export const FCM_SIGN_VALIDATION_ERROR_SAMPLE_RATE = defineFcm('sign_validation_error_sample_rate')
	.asNumber()
	.withDefault(15)
	.toConfig();
